import * as React from 'react';
import { IconPaths } from 'src/icons';

export const PrintFooter: React.SFC = () => (
  <div id="printFooter" className="clearfix">
    <div
      style={{
        textTransform: 'uppercase',
        textAlign: 'left',
        fontSize: '10pt',
        position: 'absolute',
        left: 0,
        bottom: '5px'
      }}
    >
      card.visitvillach.at
    </div>
    {/* <div className="colorbox" style={{ display: 'inline-block', content: ' ' }} /> */}
    <img
      style={{
        height: '50px',
        width: 'auto',
        position: 'absolute',
        right: 0,
        bottom: '5px'
      }}
      src={IconPaths['region-icon']}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/utils/Print/PrintFooter.tsx